module.exports = __webpack_public_path__ + "static/media/Kahili-sm.47f42d7b.jpg";